import request from '@/utils/request'

/**
 * 产品相关接口定义
 * 基于页面推断的 API 结构
 */
const ProductAPI = {
  /**
   * 获取首页 Banner 列表
   * @returns {Promise} 返回 banner 数据数组
   */
  getBanners() {
    return request({
      url: '/public/banners',
      method: 'get'
    })
  },

  /**
   * 获取课程分类列表
   * @returns {Promise} 返回分类字符串数组
   */
  getCategories() {
    return request({
      url: '/public/categories',
      method: 'get'
    })
  },

  /**
   * 获取课程列表
   * @param {Object} params 查询参数
   * @param {number} params.categoryId 分类ID/索引
   * @param {number} params.page 当前页码
   * @param {number} params.pageSize 每页数量
   * @returns {Promise} 返回课程列表数据
   */
  getCourseList(params) {
    return request({
      url: '/public/courses',
      method: 'get',
      params
    })
  },

  /**
   * 获取课程详情
   * @param {number|string} id 课程ID
   * @returns {Promise} 返回课程详细信息
   */
  getDetail(id) {
    return request({
      url: `/product/detail/${id}`,
      method: 'get'
    })
  },

  /**
   * 获取课程详情 (公开)
   * @param {number|string} id 课程ID
   * @returns {Promise} 返回课程详细信息
   */
  getPublicCourseDetail(id) {
    return request({
      url: `/public/course/${id}`,
      method: 'get'
    })
  }
}

export default ProductAPI
